import type { NodeProps } from '@xyflow/react';
import { NodeShell } from './nodeShell';

export function StatuteNode({ data, selected }: NodeProps) {
  const d = data as { title?: string; cite?: string; jurisdiction?: string; vaultLink?: string };
  return (
    <NodeShell title={d.title ?? 'Statute'} kind="statute" accent="#4b0082" selected={selected}>
      {d.cite && <div style={{ color: '#555' }}>{d.cite}</div>}
      {d.jurisdiction && <div>{d.jurisdiction}</div>}
      {d.vaultLink && <div style={{ marginTop: 2, color: '#0066cc' }}>[[{d.vaultLink}]]</div>}
    </NodeShell>
  );
}
